// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__NhpX8","withBottomBorder":"styles_withBottomBorder__U3bvb"};